import "./Title.css";
const Title = () => {
  return (
    <div className="title">
      <p>AI Assisted Product Demo</p>

      <p className="credits"></p>
    </div>
  );
};

export default Title;
